/**
 * Состояние сворачивания блоков открытой карточки.
 * Состав блоков и подписи — в taskSections.ts.
 */

import type { TaskSection } from "@taskflow/contracts";
import { type ReactNode, useMemo, useState } from "react";

import { type TaskSectionCollapse, TaskSectionCollapseContext } from "./taskSections";

export function TaskSectionsProvider({
  expanded,
  children,
}: {
  /** Развёрнутые по умолчанию блоки из профиля. */
  expanded: readonly TaskSection[];
  children: ReactNode;
}) {
  // Хранится не «что открыто», а «что пользователь переключил руками»:
  // настройки профиля приходят запросом уже после первой отрисовки, и
  // полный снимок состояния пришлось бы затирать ответом сервера — вместе
  // с тем, что человек успел свернуть.
  const [toggled, setToggled] = useState<Partial<Record<TaskSection, boolean>>>({});

  const value = useMemo<TaskSectionCollapse>(() => {
    const isOpen = (section: TaskSection) => toggled[section] ?? expanded.includes(section);
    return {
      isOpen,
      toggle: (section) =>
        setToggled((previous) => ({ ...previous, [section]: !isOpen(section) })),
    };
  }, [expanded, toggled]);

  return <TaskSectionCollapseContext value={value}>{children}</TaskSectionCollapseContext>;
}
